export class Consideration {
  categoryId: number;
  subCategoryId: number;
  section: string;
  tab: string;
  title: string;
  items: string[];
  brand?: string;

  constructor(consideration?: Consideration) {
    // This handles copying the simple properties
    if (!consideration) {
      return;
    }
    // This handles copying the simple properties
    Object.keys(consideration).forEach(key => {
      this[key] = consideration[key];
    });

    if (consideration.items) {
      this.items = consideration.items.map(item => {
        return item;
      });
    } else {
      this.items = [];
    }
  }
}
